import React, { useEffect } from "react";
import { connect } from "umi";
import DatalabIframe from "@home/components/DatalabIframe";
import { getDashboardType, getPathFromDashboard } from "@/pages/dashboard/utils/utils";
import { PAGE_TYPE_DASHBOARD_CUSTOM } from "@/pages/dashboard/_config/constant";
import { buriedPoint } from "@home/utils/buriedPoint";
import { getLanguage } from "@home/utils/common";
import { useCopilotOpenBridge } from "@/pages/aigc/pages/Agent/Copilot/hooks/useCopilotOpenBridge";
const CustomDashboard = (props: any) => {
  const { gameName, gameCode, currentMenu } = props;
  const { name_en: dashboardName, name_cn: dashboardNameCn, dashboard_custom_id: dashboardId, attributes } = currentMenu || {};
  const name = getLanguage(true, dashboardName, dashboardNameCn);
  const { openCopilotWithDefaultAgent } = useCopilotOpenBridge();

  useEffect(() => {
    if (!currentMenu || getDashboardType(currentMenu) !== PAGE_TYPE_DASHBOARD_CUSTOM) {
      return;
    }
    const path = getPathFromDashboard(currentMenu);
    buriedPoint({
      pageId: '203801',
      pageName: dashboardName,
      extInfo: '自定义报表—经分承接页',
      pagePath: `/${path}`,
      uid: gameCode || '',
      menuId: currentMenu?.id,
      typeId: "dashboard_pc_v2"
    });
  }, [currentMenu]);

  // 说明：探索页在 iframe 内通过 postMessage 通知父页面恢复菜单（GoBackReport）。
  // 当用户点击头部菜单等方式直接切路由时，承接页可能先卸载并销毁消息监听，导致最后一条“返回通知”丢失，菜单残留 display:none。
  // 这里在承接页卸载时兜底恢复菜单，避免影响后续页面的左侧菜单显示。
  useEffect(() => {
    return () => {
      const menuDom = document.getElementsByClassName('dbd-left-menu-container')[0] as HTMLElement;
      if (menuDom) {
        menuDom.style.display = 'block';
      }
    };
  }, []);

  const clickExplore = (payload: any) => {
    const { chartId, chartName: name, nameCn, type, subType } = payload || {};
    // iframe 内 AIAnalysisButton 点击 -> 复用 clickExplore 通道，通过 subType 区分
    // （避开 SDK 在 type 字段上的强制覆盖）
    if (subType === 'aiAnalysis') {
      const { gameCode: payloadGameCode, dashboardId: payloadDashboardId, form } = payload || {};
      
      openCopilotWithDefaultAgent({
        form: form || 'custom_dashboard',
        gameCode: payloadGameCode || gameCode,
        dashboardId: payloadDashboardId || dashboardId,
      });
      return;
    }

    const menuDom = document.getElementsByClassName('dbd-left-menu-container')[0] as HTMLElement;
    if (!menuDom) return;
    if (type === 'analyse') {
      const buriedPointConfig = {
        pageId: '205801',
        uid: gameCode, // 经分系统的 TODO: 从当前路径中获取gameCode
        typeId: "dashboard_pc_v2", // 经分系统
        menuId: currentMenu?.id, // 使用经分承接页面的menuId
        pageName: `${name}(Explore)`,
        pagePath: '/datalab/chart/explore',
        extInfo: `{"pageName": "${name}", "pageNameCn": "${nameCn}", "id": "${chartId}"}`,
      };
      buriedPoint(buriedPointConfig);
      menuDom.style.display = 'none';
    } else {
      menuDom.style.display = 'block';
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const clickFullscreen = (payload: any) => {
    // const { operation } = payload || {};
    // const menuDom = document.getElementsByClassName('dbd-left-menu-container')[0] as HTMLElement;
    // if (!menuDom) return;
    // if (operation === 'fullScreen') {
    //   menuDom.style.display = 'none';
    // } else {
    //   menuDom.style.display = 'block';
    // }
    // const menuDom = document.getElementsByClassName('navmenu')[0] as HTMLElement;
    // const btnDom = document.getElementsByClassName('navmenu-ft-right')[0] as HTMLElement;
    // // 菜单展开点击全屏，需要收起菜单
    // if (menuDom?.classList?.contains('normal-with') && type === 'fullScreen') {
    //   return btnDom?.click();
    // }
    // // 菜单收起点击关闭全屏，需要展开菜单
    // if (menuDom?.classList?.contains('small-with') && type === 'notFullScreen') {
    //   return btnDom?.click();
    // }
  };

  return <>
    {dashboardId && <DatalabIframe
      clickExplore={clickExplore}
      clickFullscreen={clickFullscreen}
      api={'/api/v1/dashboard/datalab_guest_token'}
      params={{
        game_code: gameCode,
        menu_id: currentMenu?.id,
        dashboard_id: currentMenu?.dashboard_custom_id
      }}
      currentMenu={currentMenu}
      gameCode={gameCode}
      paramsOfIframe={{
        gameName,
        typeId: "dashboard_pc_v2",
        exportPageId: "205801",  // 探索页面的pageId
        reportPageId: "203801", // 承接页面的pageId
      }}
      dashboardName={name}
      system='dashboard'
      attributes={attributes}
    />
    }
  </>;
};

export default connect((state: any) => ({
  gameCode: state.dashboard?.currentGame?.game_code,
  gameName: state.dashboard?.currentGame?.game_name,
  currentMenu: state?.dashboard?.currentMenu,
}))(CustomDashboard);